/* esm.sh - @noble/curves@1.9.7/abstract/modular */
export * from "/*@noble/curves@1.9.7/esnext/abstract/modular.mjs";
